import React, { Fragment, useState } from 'react'
import LocationOffIcon from '@material-ui/icons/LocationOff'
import { Dialog, Tooltip } from '@material-ui/core'
import { StyledLocationOffContainer, StyledLocationOffIcon } from './styles'
import { stateList } from '../../helpers'
import { StyledExternalLink, StyledParagraph600FontWeight0Margin } from '../../../theme/Global'

const LocationsAffected = (props) => {
  const [open, setOpen] = useState(false)
  const { data } = props

  const jurisdictionName = (data.jurisdiction && data.jurisdiction.jurisdictionName)
    || (data.jurisdiction && data.jurisdiction.name)
    || ((stateList.find((location) => location.state === data.jurisdiction.jurisdiction) || {}).name)
    || 'unknown'

  const handleOpen = () => setOpen(true)

  const close = () => setOpen(false)

  return data.locations > 0 ? (
    <Fragment>
      {props.indexed ? (
        <StyledParagraph600FontWeight0Margin data-testid="locations-affected-indexed-message">
          TBD until indexed rate is published in {jurisdictionName}
        </StyledParagraph600FontWeight0Margin>
      ) : (
        <StyledExternalLink onClick={handleOpen} data-testid="locations-affected-link">
          {props.data.locations} Location(s) in {jurisdictionName}
        </StyledExternalLink>
      )}
      {props.modal ? (
        <Dialog title="" open={props.canOpen && open} onClose={close} maxWidth="md">
          {props.modal}
        </Dialog>
      ) : null}
    </Fragment>
  ) : (
    <StyledLocationOffContainer data-testid="location-off-icon">
      <Tooltip placement="right-start" title="No locations in this jurisdiction" data-testid="location-off-tooltip">
        <StyledLocationOffIcon>
          <LocationOffIcon />
        </StyledLocationOffIcon>
      </Tooltip>
    </StyledLocationOffContainer>
  )
}

export default LocationsAffected
